import { FormControl, InputLabel, Select } from "@mui/material";
import React, { useMemo } from "react";

export default function SelectForm({
  label,
  value,
  disabled,
  onChange,
  fullWidth = true,
  name,
  id,
  options,
  addDefaultOption = false,
}) {
  const renderedOptions = useMemo(() => {
    const list = Array.isArray(options) ? [...options] : [];
    if (addDefaultOption) list.push({ value: 0, label: "" });

    return list.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ));
  }, [options, addDefaultOption]);

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel htmlFor={`${id}-select-native`}>{label}</InputLabel>
      <Select
        native
        value={value}
        disabled={disabled}
        onChange={onChange}
        fullWidth={fullWidth}
        label={label}
        inputProps={{
          name,
          id,
        }}
      >
        {renderedOptions}
      </Select>
    </FormControl>
  );
}
